import useIsPWA from '@/hooks/utilities/useIsPWA';
export default function FixedBtnWrapper({
  children,
  className
}: {
  children: any;
  className?: string;
}) {
  const isPWA = useIsPWA();
  return <div className={`z-[2000] fixButtonWrapper flex w-full border-none justify-center items-center px-2 py-4 ${isPWA ? 'pb-[11%]' : 'pb-[7%]'}  fixed bottom-[48px] 
    ${className && className}`} data-sentry-component="FixedBtnWrapper" data-sentry-source-file="FixBtnWrapper.tsx">
      <div className='w-full flex'>{children}</div>
    </div>;
}